function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgOverviewStory3(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 554.4 452.6",
    style: {
      enableBackground: "new 0 0 554.4 452.6"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_206",
    x: 1,
    y: 1,
    style: {
      fill: "#FFFFFF",
      stroke: "#221F20",
      strokeWidth: 2,
      strokeMiterlimit: 10
    },
    width: 552.4,
    height: 450.6
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1,
    y: 1,
    style: {
      fill: "#E39F5C"
    },
    width: 552.4,
    height: 63.7
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_3",
    style: {
      fill: "none",
      stroke: "#221F20",
      strokeWidth: 2,
      strokeMiterlimit: 10
    },
    x1: 1,
    y1: 64.7,
    x2: 553.4,
    y2: 64.7
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      enableBackground: "new"
    }
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M26.7,16.3H33l6.5,32.4H34l-1.3-7.5h-5.6l-1.3,7.5h-5.6L26.7,16.3z M32.1,37.5l-2.2-13.6l-2.2,13.6 H32.1z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M40,16.3h5.2l4.3,22.9l4-22.9h5.3l-6.5,32.4h-5.8L40,16.3z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M65.8,16.3h6.3l6.5,32.4h-5.5l-1.3-7.5h-5.6l-1.3,7.5h-5.6L65.8,16.3z M71.2,37.5L69,23.9l-2.2,13.6 H71.2z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M82,16.3h5.8v32.4H82V16.3z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M92.8,16.3h5.9v28.4h7.9v4H92.8V16.3z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M114.5,16.3h6.3l6.5,32.4h-5.5l-1.3-7.5h-5.6l-1.3,7.5H108L114.5,16.3z M119.9,37.5l-2.2-13.6 l-2.2,13.6H119.9z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M130.6,16.3h8c5.7,0,9.5,1.9,9.5,8.3c0,4-1.6,6.2-4.7,6.6c3.8,0.7,5.6,3.4,5.6,8c0,6.2-3,9.4-9,9.4 h-9.4V16.3z M138.5,29.5c3.5,0,4.4-1.6,4.4-4.8c0-3.4-1.7-4.3-5.3-4.3h-1.2v9.1H138.5z M138.7,44.5c3.6,0,4.6-1.7,4.6-5.3 c0-3.8-1.3-5.6-4.8-5.6h-2.1v10.9H138.7z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M152.8,16.3h5.9v28.4h7.9v4h-13.8V16.3z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M169.7,16.3h13.6v4.2h-7.7v9.3h6.1v4.1h-6.1v10.8h7.8v4h-13.7V16.3z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M196.5,16.3h7.6c7.9,0,10.3,3.2,10.3,10.1v11.8c0,7.1-2.4,10.5-10,10.5h-7.9V16.3z M204.2,44.6 c4,0,4.2-2.2,4.2-6.2V26c0-3.9-0.4-5.5-4.3-5.5h-1.8v24.1H204.2z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M223.4,16.3h6.3l6.5,32.4h-5.5l-1.3-7.5h-5.6l-1.3,7.5h-5.6L223.4,16.3z M228.8,37.5l-2.2-13.6 l-2.2,13.6H228.8z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M241.2,20.7H236v-4.4h16.1v4.4h-5v28h-5.9V20.7z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M259.1,16.3h6.3l6.5,32.4h-5.5l-1.3-7.5h-5.6l-1.3,7.5h-5.6L259.1,16.3z M264.5,37.5l-2.2-13.6 l-2.2,13.6H264.5z"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_73",
    style: {
      fill: "#E39F5C",
      stroke: "#E39F5C",
      strokeWidth: 2
    },
    d: "M19.6,100.1c-0.3-0.3-0.3-0.8,0-1.2 c0.1-0.2,0.4-0.2,0.6-0.2s0.4,0,0.6,0.2L30.9,109l21.4-21.4c0.3-0.3,0.8-0.3,1.2,0s0.3,0.8,0,1.2L31,111.3l-11.2-11.2H19.6z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_73-2",
    style: {
      fill: "#E39F5C",
      stroke: "#E39F5C",
      strokeWidth: 2
    },
    d: "M19.6,145.9c-0.3-0.3-0.3-0.8,0-1.1 c0.1-0.1,0.4-0.2,0.6-0.2s0.4,0,0.6,0.2l10.1,10.1l21.4-21.4c0.3-0.3,0.8-0.3,1.2,0s0.3,0.8,0,1.1L31,157.1l-11.2-11.2L19.6,145.9z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_73-3",
    style: {
      fill: "#E39F5C",
      stroke: "#E39F5C",
      strokeWidth: 2
    },
    d: "M19.6,189.4c-0.3-0.3-0.3-0.8,0-1.1 c0.1-0.1,0.4-0.2,0.6-0.2s0.4,0,0.6,0.2l10.1,10.1L52.3,177c0.3-0.3,0.8-0.3,1.2,0s0.3,0.8,0,1.1L31,200.6l-11.2-11.2L19.6,189.4z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_73-4",
    style: {
      fill: "#E39F5C",
      stroke: "#E39F5C",
      strokeWidth: 2
    },
    d: "M19.6,234.4c-0.3-0.3-0.3-0.8,0-1.1 c0.1-0.1,0.4-0.2,0.6-0.2s0.4,0,0.6,0.2l10.1,10.1L52.3,222c0.3-0.3,0.8-0.3,1.2,0s0.3,0.8,0,1.1L31,245.6l-11.2-11.2L19.6,234.4z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_73-5",
    style: {
      fill: "#E39F5C",
      stroke: "#E39F5C",
      strokeWidth: 2
    },
    d: "M19.6,279.2c-0.3-0.3-0.3-0.8,0-1.1 c0.1-0.1,0.4-0.2,0.6-0.2s0.4,0,0.6,0.2l10.1,10.1l21.4-21.4c0.3-0.3,0.8-0.3,1.2,0s0.3,0.8,0,1.1L31,290.4l-11.2-11.2H19.6z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_73-6",
    style: {
      fill: "#E39F5C",
      stroke: "#E39F5C",
      strokeWidth: 2
    },
    d: "M19.6,322.2c-0.3-0.3-0.3-0.8,0-1.1 c0.1-0.1,0.4-0.2,0.6-0.2s0.4,0,0.6,0.2l10.1,10.1l21.4-21.4c0.3-0.3,0.8-0.3,1.2,0s0.3,0.8,0,1.1L31,333.4l-11.2-11.2H19.6z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_73-7",
    style: {
      fill: "#E39F5C",
      stroke: "#E39F5C",
      strokeWidth: 2
    },
    d: "M19.6,366.7c-0.3-0.3-0.3-0.8,0-1.1 c0.1-0.1,0.4-0.2,0.6-0.2s0.4,0,0.6,0.2l10.1,10.1l21.4-21.4c0.3-0.3,0.8-0.3,1.2,0s0.3,0.8,0,1.1L31,377.9l-11.2-11.2H19.6z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_73-8",
    style: {
      fill: "#E39F5C",
      stroke: "#E39F5C",
      strokeWidth: 2
    },
    d: "M19.6,411.5c-0.3-0.3-0.3-0.8,0-1.1 c0.1-0.1,0.4-0.2,0.6-0.2s0.4,0,0.6,0.2l10.1,10.1l21.4-21.4c0.3-0.3,0.8-0.3,1.2,0s0.3,0.8,0,1.1L31,422.7l-11.2-11.2H19.6z"
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_9",
    style: {
      fill: "none",
      stroke: "#6D6D6D",
      strokeWidth: 16,
      strokeLinecap: "round"
    },
    x1: 131.4,
    y1: 99.3,
    x2: 75.4,
    y2: 99.3
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_9-2",
    style: {
      fill: "none",
      stroke: "#6D6D6D",
      strokeWidth: 16,
      strokeLinecap: "round"
    },
    x1: 131.4,
    y1: 188.7,
    x2: 75.4,
    y2: 188.7
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_9-3",
    style: {
      fill: "none",
      stroke: "#898989",
      strokeWidth: 16,
      strokeLinecap: "round"
    },
    x1: 131.4,
    y1: 413,
    x2: 75.4,
    y2: 413
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_9-4",
    style: {
      fill: "none",
      stroke: "#6D6D6D",
      strokeWidth: 16,
      strokeLinecap: "round"
    },
    x1: 166.1,
    y1: 413,
    x2: 152.4,
    y2: 413
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_9-5",
    style: {
      fill: "none",
      stroke: "#898989",
      strokeWidth: 16,
      strokeLinecap: "round"
    },
    x1: 168.8,
    y1: 234.9,
    x2: 75.4,
    y2: 234.9
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_9-6",
    style: {
      fill: "none",
      stroke: "#A5A5A5",
      strokeWidth: 16,
      strokeLinecap: "round"
    },
    x1: 231.2,
    y1: 188.7,
    x2: 192.1,
    y2: 188.7
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_9-7",
    style: {
      fill: "none",
      stroke: "#A5A5A5",
      strokeWidth: 16,
      strokeLinecap: "round"
    },
    x1: 256.5,
    y1: 145.1,
    x2: 220.4,
    y2: 145.1
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_11",
    style: {
      fill: "none",
      stroke: "#6D6D6D",
      strokeWidth: 16,
      strokeLinecap: "round"
    },
    x1: 356.5,
    y1: 145.1,
    x2: 300.9,
    y2: 145.1
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_9-8",
    style: {
      fill: "none",
      stroke: "#898989",
      strokeWidth: 16,
      strokeLinecap: "round"
    },
    x1: 199,
    y1: 145.1,
    x2: 75.4,
    y2: 145.1
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_11-2",
    style: {
      fill: "none",
      stroke: "#898989",
      strokeWidth: 16,
      strokeLinecap: "round"
    },
    x1: 280.7,
    y1: 145.1,
    x2: 277.7,
    y2: 145.1
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_9-9",
    style: {
      fill: "none",
      stroke: "#898989",
      strokeWidth: 16,
      strokeLinecap: "round"
    },
    x1: 231.9,
    y1: 278.4,
    x2: 174.6,
    y2: 278.4
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_9-10",
    style: {
      fill: "none",
      stroke: "#A5A5A5",
      strokeWidth: 16,
      strokeLinecap: "round"
    },
    x1: 154.1,
    y1: 278.4,
    x2: 75.4,
    y2: 278.4
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_11-3",
    style: {
      fill: "none",
      stroke: "#6D6D6D",
      strokeWidth: 16,
      strokeLinecap: "round"
    },
    x1: 271.8,
    y1: 278.4,
    x2: 253.5,
    y2: 278.4
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_11-4",
    style: {
      fill: "none",
      stroke: "#898989",
      strokeWidth: 16,
      strokeLinecap: "round"
    },
    x1: 170.6,
    y1: 188.7,
    x2: 152.4,
    y2: 188.7
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_9-11",
    style: {
      fill: "none",
      stroke: "#6D6D6D",
      strokeWidth: 16,
      strokeLinecap: "round"
    },
    x1: 277.7,
    y1: 323,
    x2: 186.6,
    y2: 323
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_9-12",
    style: {
      fill: "none",
      stroke: "#898989",
      strokeWidth: 16,
      strokeLinecap: "round"
    },
    x1: 166.1,
    y1: 323,
    x2: 75.4,
    y2: 323
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_11-5",
    style: {
      fill: "none",
      stroke: "#A5A5A5",
      strokeWidth: 16,
      strokeLinecap: "round"
    },
    x1: 317.2,
    y1: 323,
    x2: 298.9,
    y2: 323
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_9-13",
    style: {
      fill: "none",
      stroke: "#A5A5A5",
      strokeWidth: 16,
      strokeLinecap: "round"
    },
    x1: 298.9,
    y1: 367.5,
    x2: 244.8,
    y2: 367.5
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_9-14",
    style: {
      fill: "none",
      stroke: "#898989",
      strokeWidth: 16,
      strokeLinecap: "round"
    },
    x1: 223.5,
    y1: 367.5,
    x2: 152.4,
    y2: 367.5
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_9-15",
    style: {
      fill: "none",
      stroke: "#6D6D6D",
      strokeWidth: 16,
      strokeLinecap: "round"
    },
    x1: 131.4,
    y1: 367.5,
    x2: 75.4,
    y2: 367.5
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_11-6",
    style: {
      fill: "none",
      stroke: "#898989",
      strokeWidth: 16,
      strokeLinecap: "round"
    },
    x1: 356.5,
    y1: 367.5,
    x2: 320.1,
    y2: 367.5
  }));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgOverviewStory3);
export default __webpack_public_path__ + "static/media/overview-story3.3136a712.svg";
export { ForwardRef as ReactComponent };